// extracted by mini-css-extract-plugin
export default {"root":"rjFqH","apps":"CCgeT","app":"u0WUi"};